import type * as THREE from 'three'
import type { CameraState, ViewportRect } from '@/shared/types/core'
import type { ViewportCamera } from '@/shared/types/services'

/**
 * 代理型 ViewportCamera，将调用转发至当前活动视图的 ViewportCamera。
 */
export class ActiveViewViewportCameraFacade implements ViewportCamera {
  constructor(private readonly getActiveViewport: () => ViewportCamera) {}

  /** 活动视图的透视相机 */
  get perspectiveCamera(): THREE.PerspectiveCamera {
    return this.getActiveViewport().perspectiveCamera
  }

  /** 活动视图的正交相机 */
  get orthographicCamera(): THREE.OrthographicCamera {
    return this.getActiveViewport().orthographicCamera
  }

  /**
   * 获取当前活动相机。
   *
   * @returns 透视或正交相机实例
   */
  getActiveCamera(): THREE.Camera {
    return this.getActiveViewport().getActiveCamera()
  }

  /**
   * 获取透视相机实例。
   *
   * @returns 透视相机
   */
  getPerspectiveCamera(): THREE.PerspectiveCamera {
    return this.getActiveViewport().getPerspectiveCamera()
  }

  /**
   * 获取正交相机实例。
   *
   * @returns 正交相机
   */
  getOrthographicCamera(): THREE.OrthographicCamera {
    return this.getActiveViewport().getOrthographicCamera()
  }

  /**
   * 根据 rig 状态同步相机投影与位姿。
   *
   * @param state - 相机状态
   * @param near - 近裁剪距离
   * @param far - 远裁剪距离
   * @param viewport - 视口矩形
   */
  syncFromRig(state: CameraState, near: number, far: number, viewport: ViewportRect): void {
    this.getActiveViewport().syncFromRig(state, near, far, viewport)
  }

  /** 释放代理（空实现，具体实现自行释放） */
  dispose(): void {}
}
